export const InvestmentDecisionStatusLabel = {
    N: 'New',
    S: 'Submitted',
    A: 'Approved',
    D: 'Deferred',
    R: 'Rejected',
    P: 'Planned',
    I: 'In Progress',
    O: 'Complete',
    C: 'Cancelled',
};
export const InvestmentDecisionStatusColor = {
    N: 'gray',
    S: 'blue',
    A: 'green',
    D: 'yellow',
    R: 'red',
    P: 'purple',
    I: 'indigo',
    O: 'emerald',
    C: 'gray',
};
/**
 * Maps investment status values to decision status codes
 */
export const InvestmentStatusToDecisionStatus = {
    new: 'N',
    submitted: 'S',
    approved: 'A',
    deferred: 'D',
    rejected: 'R',
    planned: 'P',
    in_progress: 'I',
    complete: 'O',
    cancelled: 'C',
};
/**
 * Maps decision status codes to investment status values
 */
export const DecisionStatusToInvestmentStatus = {
    N: 'new',
    S: 'submitted',
    A: 'approved',
    D: 'deferred',
    R: 'rejected',
    P: 'planned',
    I: 'in_progress',
    O: 'complete',
    C: 'cancelled',
};
/**
 * List of investment statuses that require DecisionMaker role
 */
export const RESTRICTED_STATUSES = ['approved', 'deferred', 'rejected', 'cancelled'];
/**
 * Check if a status requires DecisionMaker role
 */
export function isRestrictedStatus(status) {
    return RESTRICTED_STATUSES.includes(status);
}
//# sourceMappingURL=decision-status.enum.js.map